export const RequiredVaccinations = [
  {
    name: 'Rabies [Initial]',
    core: true,
    expiration: 1,
  },
  {
    name: 'Rabies [Continuing]',
    core: true,
    expiration: 3,
  },
  {
    name: 'DAP',
    core: true,
    expiration: 3,
  },
  {
    name: 'Leptospirosis',
    core: false,
    expiration: 1,
  },
  {
    name: 'Lyme',
    core: false,
    expiration: 1,
  },
  {
    name: 'Canine Influenza',
    core: false,
    expiration: 1,
  },
  {
    name: 'Bordetella',
    core: false,
    expiration: 1,
  },
];


export const isVaccinationUpToDate = (vaccination) => {
  const today = new Date();
  const expirationDate = new Date(vaccination.expirationDate);
  return today <= expirationDate;
};


export const getVaccinationsStatus = (vaccinations, requiredVaccinations) => {
  if (!vaccinations) {
    return { 
      missingVaccinations: requiredVaccinations.filter(v => v.core).map(rs => rs.name), 
      expiredVaccinations: [],
      unverifiedVaccinations: []
    };
  }

  const missingVaccinations = [];
  const expiredVaccinations = [];
  const unverifiedVaccinations = [];
  
  // Check for up-to-date Rabies vaccinations
  const validRabiesVaccinations = vaccinations.filter(v => 
    (v.name === 'Rabies [Initial]' || v.name === 'Rabies [Continuing]') && 
    isVaccinationUpToDate(v)
  );
  
  const hasValidRabies = validRabiesVaccinations.length > 0;
  const hasVerifiedValidRabies = validRabiesVaccinations.some(v => v.verifiedByEmployee);
  
  // Check for expired vaccinations, handling Rabies specially
  for (let vaccination of vaccinations) {
    if (!isVaccinationUpToDate(vaccination)) {
      // Only add Rabies to expired list if both initial and continuing are expired
      if (vaccination.name === 'Rabies [Initial]' || vaccination.name === 'Rabies [Continuing]') {
        if (!hasValidRabies) {
          // Only add Continuing Rabies to expired list if neither is valid
          if (vaccination.name === 'Rabies [Continuing]') {
            expiredVaccinations.push(vaccination.name);
          }
        }
      } else {
        // For non-Rabies vaccinations, add to expired list as before
        expiredVaccinations.push(vaccination.name);
      }
    }
  }

  for (let requiredVaccination of requiredVaccinations) {
    if (!requiredVaccination.core) continue;
    
    // For Rabies, we only need either a valid initial OR continuing vaccination
    if (requiredVaccination.name === 'Rabies [Initial]' || requiredVaccination.name === 'Rabies [Continuing]') {
      if (hasValidRabies) {
        continue; // Skip both Rabies checks if we have either valid vaccination
      } else {
        // If neither is valid, add the continuing Rabies as missing (since that's what we'd want for an older dog)
        missingVaccinations.push('Rabies [Continuing]');
        continue;
      }
    }
    
    const existingVaccination = vaccinations.find(v => v.name === requiredVaccination.name);
    if (!existingVaccination || !isVaccinationUpToDate(existingVaccination)) {
      missingVaccinations.push(requiredVaccination.name);
    }
  }

  // Check verification status for core vaccinations that are valid
  for (let vaccination of vaccinations) {
    const isCore = requiredVaccinations.find(v => v.name === vaccination.name)?.core;
    if (isCore && isVaccinationUpToDate(vaccination)) {
      // For Rabies, only add to unverified if we don't have any verified valid Rabies vaccination
      if ((vaccination.name === 'Rabies [Initial]' || vaccination.name === 'Rabies [Continuing]')) {
        if (!hasVerifiedValidRabies) {
          unverifiedVaccinations.push('Rabies');
        }
      } else if (!vaccination.verifiedByEmployee) {
        unverifiedVaccinations.push(vaccination.name);
      }
    }
  }

  // Remove duplicate Rabies entries from unverifiedVaccinations
  const uniqueUnverifiedVaccinations = unverifiedVaccinations.filter((name, index, self) => 
    self.indexOf(name) === index
  );

  return { 
    missingVaccinations, 
    expiredVaccinations, 
    unverifiedVaccinations: uniqueUnverifiedVaccinations 
  };
};
